import React from 'react';
import Botao from './Botao';

/**
 * Tabela — lista de registros. Abaixo de 640 px cada linha vira cartão.
 * colunas: [{ chave, titulo, direita? }]. A primeira coluna é o nome que abre a ficha.
 * linhas: [{ id, ...dados }]. Para uma célula que não é a principal, o rótulo vem de `data-rotulo`.
 * Quando `aoAbrir` existe, a primeira coluna vira botão.
 */
export default function Tabela({ colunas, linhas, aoAbrir, vazio = null, compacta = false, rotulo = 'Lista' }) {
  if (!linhas.length) return vazio;

  return (
    <div className="sj-tabela-moldura">
      <table className={['sj-tabela', compacta ? 'sj-tabela--compacta' : ''].filter(Boolean).join(' ')} aria-label={rotulo}>
        <thead>
          <tr>
            {colunas.map((c) => (
              <th key={c.chave} scope="col" className={c.direita ? 'sj-direita' : undefined}>{c.titulo}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha) => (
            <tr key={linha.id}>
              {colunas.map((c, i) => {
                const conteudo = c.render ? c.render(linha) : linha[c.chave];
                const principal = i === 0;
                return (
                  <td
                    key={c.chave}
                    data-rotulo={principal ? undefined : c.titulo}
                    className={[principal ? 'sj-tabela__principal' : '', c.direita ? 'sj-direita sj-num' : ''].filter(Boolean).join(' ') || undefined}
                  >
                    {principal && aoAbrir
                      ? <Botao variante="fantasma" tamanho="sm" onClick={() => aoAbrir(linha)}>{conteudo}</Botao>
                      : conteudo}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
